/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Dec 31 2024
 **/

import { css } from "@emotion/react";

export const GridContentStyle = css`
	position: relative;
	display: flex;
	align-items: center;
	cursor: pointer;
	&.show::after {
		content: "✔";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 15px;
		z-index: 15;
		pointer-events: none;
		color: #616161;
	}
`;

export const ImageContentStyle = css`
	width: 32px;
	height: 32px;
`;
